import * as React from "react";
import { useId } from "@floating-ui/react";
import { Carousel } from "../../../carousel/carousel/carousel.mjs";
import { CarouselItem } from "../../../carousel/carousel/carousel-item.mjs";
import { FormHelper } from "../../form-helper/form-helper.mjs";
import { Grid } from "../../../grid/grid/grid.mjs";
import { GridColumn } from "../../../grid/grid-column/grid-column.mjs";
import { OptionCard } from "../../option-card/option-card/option-card.mjs";
import { PropsChecker } from "../../../helpers/props-checker/props-checker.mjs";
const OptionCardGroup = (props) => {
  const id = useId();
  return /* @__PURE__ */ React.createElement(PropsChecker, { componentName: "OptionCardGroup", componentProps: props, defaultValueName: "defaultValue", valueName: "value", onChangeNames: "onChange" }, /* @__PURE__ */ React.createElement(OptionCardGroupInner, { ...props, id }));
};
class OptionCardGroupInner extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = (value, checked, onChange) => {
      let newValue = null;
      if (this.props.inputType === "checkbox") {
        newValue = Array.isArray(this.value) ? [...this.value] : [];
        if (checked) {
          newValue.push(value);
        } else {
          newValue = newValue.filter((item) => item !== value);
        }
      } else {
        newValue = value;
      }
      if (typeof this.props.value === "undefined") {
        this.setState({
          value: newValue
        });
      }
      if (this.props.onChange) {
        this.props.onChange(newValue);
      }
      if (onChange) {
        onChange(checked);
      }
    };
    this.renderInstructions = () => {
      const { label, labelSize = "h3", helpMessage, errorMessage, successMessage, employeeMessage } = this.props;
      if (!helpMessage && !errorMessage && !successMessage && !employeeMessage) {
        return /* @__PURE__ */ React.createElement("div", { className: "option-card-group__legend ".concat(labelSize), "aria-hidden": "true" }, label);
      }
      return /* @__PURE__ */ React.createElement("div", { className: "option-card-group__content" }, /* @__PURE__ */ React.createElement("div", { className: "option-card-group__legend ".concat(labelSize), "aria-hidden": "true" }, label), helpMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: helpMessage, size: "large", type: "help", className: "option-card-group__helper" }), errorMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: errorMessage, size: "large", type: "error", className: "option-card-group__helper" }), successMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: successMessage, size: "large", type: "valid", className: "option-card-group__helper" }), employeeMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: employeeMessage, size: "large", type: "employee", className: "option-card-group__helper" }));
    };
    this.state = {
      value: props.defaultValue || null
    };
  }
  get value() {
    return this.props.onChange && typeof this.props.value !== "undefined" ? this.props.value : this.state.value;
  }
  isChecked(value) {
    const currentValue = this.value;
    if (this.props.inputType === "checkbox" && currentValue) {
      return value === currentValue || currentValue.indexOf(value) !== -1;
    } else {
      return value === currentValue;
    }
  }
  get isInvalid() {
    return !!this.props.isInvalid || !!this.props.errorMessage;
  }
  get optionCardProps() {
    const { background, type } = this.props;
    return {
      background,
      type
    };
  }
  getOptionInput(option) {
    if (this.props.inputType === "radio") {
      return {
        ...option.input,
        name: this.props.name
      };
    } else {
      return {
        ...option.input
      };
    }
  }
  renderOptionCard(child, key) {
    var _a, _b;
    const { background, type, padding } = this.props;
    const props = child.props;
    const value = (_a = props.value) != null ? _a : "on";
    const onChange = (checked) => this.onChange(value, checked, props.onChange);
    return /* @__PURE__ */ React.createElement(
      OptionCard,
      {
        ...this.optionCardProps,
        ...props,
        checked: this.isChecked(value),
        index: key,
        input: this.getOptionInput(props),
        inputType: this.props.inputType,
        onChange,
        isInvalid: this.isInvalid,
        background: (_b = props.background) != null ? _b : background,
        type,
        padding: props.padding || padding
      }
    );
  }
  getChildren() {
    return React.Children.toArray(this.props.children).filter((child) => {
      return React.isValidElement(child);
    }).map((child, key) => {
      var _a, _b;
      const isOptionCard = child && child.type === OptionCard;
      if (this.props.carousel) {
        return /* @__PURE__ */ React.createElement(CarouselItem, { key: (_a = child.props.id) != null ? _a : key }, isOptionCard ? this.renderOptionCard(child, key) : child);
      }
      return /* @__PURE__ */ React.createElement(GridColumn, { ...this.props.gridColumn, key: (_b = child.props.id) != null ? _b : key }, isOptionCard ? this.renderOptionCard(child, key) : child);
    });
  }
  BEM() {
    const classArray = ["option-card-group"];
    if (this.props.hideLabel) {
      if (this.props.hideLabel === true) {
        classArray.push("option-card-group--hide-label");
      } else {
        classArray.push("option-card-group--hide-label-".concat(this.props.hideLabel));
      }
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  render() {
    const { grid, carousel, label, inputType, labelSize = "h3", id } = this.props;
    const Element = "fieldset";
    return /* @__PURE__ */ React.createElement(
      Element,
      {
        className: this.BEM(),
        role: inputType === "radio" ? "radiogroup" : void 0,
        onClick: (e) => e.stopPropagation()
      },
      /* @__PURE__ */ React.createElement("legend", { className: "option-card-group__legend ".concat(labelSize), id: "".concat(id, "-label") }, label),
      !carousel && this.renderInstructions(),
      carousel ? /* @__PURE__ */ React.createElement(Carousel, { ...carousel, beforeSlidesContent: this.renderInstructions(), "aria-labelledby": "".concat(id, "-label") }, this.getChildren()) : /* @__PURE__ */ React.createElement(Grid, { equalHeight: true, ...grid }, this.getChildren())
    );
  }
}
export {
  OptionCardGroup
};
